/*
 * SmellWell fix — Kaching bundle quantities were doubling (a 2-pack added 4 units).
 *
 * Root cause: assets/product.js binds its add-to-cart submit handler to the <form>
 * element looked up by id (`document.getElementById('product-form-' + section)`),
 * not to the <product-form> custom element itself, and never removes it. Any second
 * ProductForm instance — including a transient one created and discarded by an app
 * re-rendering the product block — permanently stacks another handler on that form.
 * One click then fires N handlers, each POSTing /cart/add with the bundle quantity.
 *
 * Verified on the live theme 2026-07-29: one click on Add to cart produced two
 * POST /cart/add requests with quantity=2, 3ms apart, both from onSubmitHandler.
 *
 * This file must load BEFORE product.js (it is injected in <head> from theme.liquid).
 */
(function () {
  if (window.__atcGuardInstalled) return;
  window.__atcGuardInstalled = true;

  var nativeAdd = EventTarget.prototype.addEventListener;

  function isCartAddForm(el) {
    return (
      el instanceof HTMLFormElement &&
      (el.getAttribute('action') || '').indexOf('/cart/add') !== -1
    );
  }

  /*
   * Narrow de-dupe. product.js binds `this.onSubmitHandler.bind(this)`, so the
   * listener function is named exactly 'bound onSubmitHandler'. We only ever drop a
   * repeat of THAT handler on THAT form — submit listeners belonging to any other
   * app or script are passed through untouched.
   */
  EventTarget.prototype.addEventListener = function (type, listener, options) {
    try {
      if (
        type === 'submit' &&
        listener &&
        listener.name === 'bound onSubmitHandler' &&
        isCartAddForm(this)
      ) {
        if (this.__atcThemeHandlerBound) {
          if (window.console && console.info) {
            console.info('[atc-guard] dropped duplicate theme add-to-cart handler');
          }
          return;
        }
        this.__atcThemeHandlerBound = true;
      }
    } catch (e) {
      /* never let the guard interfere with normal binding */
    }
    return nativeAdd.call(this, type, listener, options);
  };

  /*
   * Second line of defence, for genuine double-taps: swallow a new submit while a
   * previous one is still in flight. Capture phase on document, so it runs before
   * the handlers bound on the form itself.
   */
  document.addEventListener(
    'submit',
    function (evt) {
      if (!isCartAddForm(evt.target)) return;

      if (window.__atcInFlight) {
        evt.preventDefault();
        evt.stopImmediatePropagation();
        return;
      }

      window.__atcInFlight = true;
      clearTimeout(window.__atcInFlightTimer);
      // Failsafe: never leave add-to-cart stuck off if a request never settles.
      window.__atcInFlightTimer = setTimeout(function () {
        window.__atcInFlight = false;
      }, 4000);
    },
    true
  );

  // Release the lock as soon as the theme reports the outcome.
  ['cart:item-added', 'product:variant-error', 'cart-drawer:open'].forEach(function (name) {
    document.addEventListener(name, function () {
      window.__atcInFlight = false;
      clearTimeout(window.__atcInFlightTimer);
    });
  });
})();
